import PropTypes from "prop-types";
import { spacing, validSpacingValues, validBreakpointValues } from "@nib-components/theme";
var validFlexWidthValues = ["content", "1/2", "1/3", "2/3", "1/4", "3/4", "1/5", "2/5", "3/5", "4/5", "1"];
var validTilesColumnsValues = [0, 1, 2, 3, 4, 5, 6];
var validFlexAlignValues = ["center", "right", "left"];
var validFlexVerticalAlignValues = ["center", "top", "bottom", "stretch"];
var spacePropType = PropTypes.oneOf(validSpacingValues);
var tilesColumnsPropType = PropTypes.oneOf(validTilesColumnsValues);
var flexWidthsPropType = PropTypes.oneOf(validFlexWidthValues);
var flexAlignmentPropType = PropTypes.oneOf(validFlexAlignValues);
var flexVerticalAlignmentPropType = PropTypes.oneOf(validFlexVerticalAlignValues);
export var breakpointPropTypes = PropTypes.oneOf(validBreakpointValues);
export var isValidSpacing = function isValidSpacing(value) {
  return value || value === 0;
};
export var getSpacingValue = function getSpacingValue(value) {
  return spacing[value];
};
export var isList = function isList(el) {
  return ["ul", "ol"].includes(el);
};
export var mapFlexWidths = function mapFlexWidths(width) {
  switch (width) {
    case "1/2":
      return 1 / 2 * 100;
    case "1/3":
      return 1 / 3 * 100;
    case "2/3":
      return 2 / 3 * 100;
    case "1/4":
      return 1 / 4 * 100;
    case "3/4":
      return 3 / 4 * 100;
    case "1/5":
      return 1 / 5 * 100;
    case "2/5":
      return 2 / 5 * 100;
    case "3/5":
      return 3 / 5 * 100;
    case "4/5":
      return 4 / 5 * 100;
  }
};
export var mapColumnstoFlexBasis = function mapColumnstoFlexBasis(columns) {
  switch (columns) {
    case 1:
    default:
      return "flex: 0 0 100%;";
    case 2:
      return "flex: 0 0 50%;";
    case 3:
      return "flex: 0 0 33.3333333333%;";
    case 4:
      return "flex: 0 0 25%;";
    case 5:
      return "flex: 0 0 20%;";
    case 6:
      return "flex: 0 0 16.6666666667%;";
  }
};
export var mapFlexAlignment = function mapFlexAlignment(flexAlignment) {
  if (flexAlignment === "center") {
    return "center";
  } else if (flexAlignment === "right" || flexAlignment === "bottom") {
    return "flex-end";
  } else if (flexAlignment === "left" || flexAlignment === "top") {
    return "flex-start";
  } else {
    return "stretch";
  }
};
export var spacingPropTypeMap = PropTypes.oneOfType([spacePropType, PropTypes.shape({
  xs: spacePropType,
  sm: spacePropType,
  md: spacePropType,
  lg: spacePropType,
  xl: spacePropType,
  xxl: spacePropType,
  xxxl: spacePropType
})]);
export var tilesColumnsPropTypeMap = PropTypes.oneOfType([tilesColumnsPropType, PropTypes.shape({
  xs: tilesColumnsPropType,
  sm: tilesColumnsPropType,
  md: tilesColumnsPropType,
  lg: tilesColumnsPropType,
  xl: tilesColumnsPropType,
  xxl: tilesColumnsPropType,
  xxxl: tilesColumnsPropType
})]);
export var flexWidthsPropTypeMap = PropTypes.oneOfType([flexWidthsPropType, PropTypes.shape({
  xs: flexWidthsPropType,
  sm: flexWidthsPropType,
  md: flexWidthsPropType,
  lg: flexWidthsPropType,
  xl: flexWidthsPropType,
  xxl: flexWidthsPropType,
  xxxl: flexWidthsPropType
})]);
export var flexAlignmentPropTypeMap = PropTypes.oneOfType([flexAlignmentPropType, PropTypes.shape({
  xs: flexAlignmentPropType,
  sm: flexAlignmentPropType,
  md: flexAlignmentPropType,
  lg: flexAlignmentPropType,
  xl: flexAlignmentPropType,
  xxl: flexAlignmentPropType,
  xxxl: flexAlignmentPropType
})]);
export var flexVerticalAlignmentPropTypeMap = PropTypes.oneOfType([flexVerticalAlignmentPropType, PropTypes.shape({
  xs: flexVerticalAlignmentPropType,
  sm: flexVerticalAlignmentPropType,
  md: flexVerticalAlignmentPropType,
  lg: flexVerticalAlignmentPropType,
  xl: flexVerticalAlignmentPropType,
  xxl: flexVerticalAlignmentPropType,
  xxxl: flexVerticalAlignmentPropType
})]);